module.exports = "<ea-add-card-page></ea-add-card-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaCardDetails/eaAddCardPage/eaAddCardPageModule.tpl.html
// module id = 1047
// module chunks = 12